import {
  CrossSell,
  ProductSelector,
  Replenishment,
} from 'components/products/relations';
import { CardBackground } from 'components/ui';
import { omit } from 'lodash';
import querystring from 'querystring';
import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import { useGetRelationsProductListQuery } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';
import { InitialLoadingPlaceholder } from './InitialLoadingPlaceholder';
import { InstructionsGraphics } from './InstructionsGraphics';

export const RelationsGrid = () => {
  const { rawQueryParams } = useParseURLQueryParams();

  const { product_id } = rawQueryParams;

  const { store_name, start_date, end_date } = rawQueryParams;

  const queryParams = querystring.stringify(
    omit(
      {
        ...rawQueryParams,
      },
      ['product_id']
    )
  );

  const {
    output: { filtersApiPayload },
  } = useAppSelector(composableFiltersState);

  const { data } = useGetRelationsProductListQuery(
    { serializedParams: queryParams, body: filtersApiPayload },
    {
      skip: !!!store_name || !!!start_date || !!!end_date,
    }
  );

  if (!!!data?.length) {
    return <InitialLoadingPlaceholder />;
  }

  return (
    <div>
      <div className="flex px-5 mb-2 space-x-64">
        <p className="font-bold leading-4 text-segments-13px">Products</p>
        <p className="pl-3 font-bold leading-4 text-segments-13px">Relations</p>
      </div>
      <CardBackground>
        <div className="grid grid-cols-segments-auto-1fr min-h-[900px]">
          <div className="border-r w-segments-331px">
            <ProductSelector />
          </div>
          {!!!product_id ? (
            <div className="flex flex-col items-center justify-center space-y-5 text-black text-opacity-30">
              <InstructionsGraphics />
              <p>Select a product to analyze</p>
            </div>
          ) : (
            <div className="p-5 ">
              {/* <FilterResults /> */}
              <CrossSell />
              <Replenishment />
            </div>
          )}
        </div>
      </CardBackground>
    </div>
  );
};
